module.exports = __webpack_public_path__ + "static/img/10.0acd913.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/10.png
// module id = PFxc
// module chunks = 0